module.exports = __webpack_public_path__ + "static/media/icon-piece2-3.3516b752.png";